import { Send, Mic, Square } from "lucide-react";

export function ChatMessages({ messages, endRef }) {
  return (
    <div className="flex-1 overflow-y-auto p-4 space-y-3 bg-[#FAF8F5]" data-testid="ai-messages">
      {messages.map((m) => (
        <div key={m.id} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
          <div className={`max-w-[85%] px-4 py-2.5 rounded-2xl text-[15px] leading-relaxed ${
            m.role === "user" ? "bg-[#D96B43] text-white rounded-br-sm" : "bg-white border border-[#E2D9CE] text-slate-800 rounded-bl-sm"
          }`}>
            {m.content || (
              <span className="flex gap-1 py-1">
                <span className="k-dot w-2 h-2 bg-slate-400 rounded-full" />
                <span className="k-dot w-2 h-2 bg-slate-400 rounded-full" />
                <span className="k-dot w-2 h-2 bg-slate-400 rounded-full" />
              </span>
            )}
          </div>
        </div>
      ))}
      <div ref={endRef} />
    </div>
  );
}

export function VoiceStatus({ voice, speaking, onStop }) {
  if (!(voice.recording || voice.transcribing || speaking)) return null;
  return (
    <div data-testid="ai-voice-status" className="px-4 py-2 text-sm font-medium bg-[#E8F4F1] text-[#2E7D6B] flex items-center justify-between">
      <span>{voice.recording ? "Listening… tap the square when you're done" : voice.transcribing ? "Understanding what you said…" : "Speaking…"}</span>
      {speaking && <button data-testid="ai-stop-speaking" onClick={onStop} className="underline">Stop</button>}
    </div>
  );
}

export function ChatComposer({ input, setInput, send, busy, voice }) {
  return (
    <div className="p-3 border-t border-[#E2D9CE] flex gap-2 bg-white">
      <button data-testid="ai-mic-btn" onClick={voice.recording ? voice.stop : voice.start} disabled={busy || voice.transcribing}
        title={voice.recording ? "Stop recording" : "Talk to Companion"}
        className={`rounded-xl px-4 min-h-[48px] flex items-center transition-colors disabled:opacity-50 ${voice.recording ? "bg-red-500 hover:bg-red-600 text-white animate-pulse" : "bg-[#FBEBE4] hover:bg-[#f5d9cc] text-[#C25832]"}`}>
        {voice.recording ? <Square className="w-5 h-5" /> : <Mic className="w-5 h-5" />}
      </button>
      <input data-testid="ai-input" value={input} onChange={(e) => setInput(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()}
        placeholder={voice.recording ? "Listening…" : "Type or tap the mic to talk…"}
        className="flex-1 px-4 min-h-[48px] rounded-xl border border-[#E2D9CE] focus:border-[#2E7D6B] focus:ring-2 focus:ring-[#2E7D6B]/20 outline-none" />
      <button data-testid="ai-send-btn" onClick={() => send()} disabled={busy}
        className="bg-[#2E7D6B] hover:bg-[#256658] disabled:opacity-50 text-white rounded-xl px-4 min-h-[48px] flex items-center">
        <Send className="w-5 h-5" />
      </button>
    </div>
  );
}
